import axios from "axios";
import notificationdata from "../datadummy/notification.json";
import {
  SET_LOADER,
  CLEAR_ERRORS,
  CLEAR_LOADER,
  GET_ALL_NOTIFICATIONS,
  GET_SINGLE_NOTIFICATION,
} from "../types";
import { setErrors } from "../actions/errorActions";
import { serverApi } from "../../config/Keys";
import { onClickSound } from "../../enums/NotificationSound";

export const get_all_notifications =
  (vendor_id, serviceType) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_all_notifications = await axios.get(
        `${serverApi}/notifications/${vendor_id}?serviceType=${serviceType}&vendor=true`
      );
      if (get_all_notifications.data) {
        dispatch({
          type: GET_ALL_NOTIFICATIONS,
          payload: get_all_notifications.data,
        });
        // dispatch(() => onClickSound());
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_single_notifications =
  (vendor_id, serviceType, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_single_notifications = await axios.get(
        `${serverApi}/notifications/${vendor_id}?serviceType=${serviceType}&vendor=true`
      );
      if (get_single_notifications.data) {
        dispatch({
          type: GET_SINGLE_NOTIFICATION,
          payload: get_single_notifications.data,
        });
        onSuccess();
        // dispatch(() => onClickSound());
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const update_notification =
  (formData, vendor_id, onSuccess) => async (dispatch) => {
    // actionBy
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let update_single_notifications = await axios.put(
        `${serverApi}/notifications/${vendor_id}`,
        formData
      );
      if (update_single_notifications.data) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
        // dispatch(get_single_notifications(vendor_id, actionBy));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const update_all_notification = (key, value) => (dispatch) => {
  try {
    let { data } = notificationdata;
    data.forEach((notify) => {
      notify[key] = value;
    });
    dispatch({
      type: GET_ALL_NOTIFICATIONS,
      payload: data,
    });
  } catch (err) {
    // PERFORM ERROR HANDLING HERE
    console.log(err);
  }
};

export const mark_all_as_read =
  (formData, vendor_id, actionBy, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let mark_all_as_read_notification = await axios.put(
        `${serverApi}/notifications/${vendor_id}`,
        formData
      );
      if (mark_all_as_read_notification.data) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
        // dispatch(get_single_notifications(vendor_id, actionBy));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const clear_all_as_read =
  (formData, vendor_id, actionBy, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let clear_all_as_read_notification = await axios.put(
        `${serverApi}/notifications/${vendor_id}`,
        formData
      );
      if (clear_all_as_read_notification.data) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
        // dispatch(get_single_notifications(vendor_id, actionBy));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
